import types from '../../config/types.js'
import MockServer from './MockServer.js'
import MeterConfigService from 'Services/MeterConfigService.js'
import ServiceData from 'Mixins/ServiceData.js'

export default {
  mixins: [MockServer, ServiceData],
  data() {
    return {
      addressList: [this.getBlankAddress()],
      meterConfigService: MeterConfigService,
    }
  },
  computed: {
    actions() {
      return {
        default: [
          // {
          //   id: 2,
          //   type: types.actions.button,
          //   attr: {
          //     type: "secondary",
          //     label: "Добавить дом",
          //     disabled: !this.isAddNewAvailable,
          //     icon: "plus-outlined",
          //     handler: () => this.addAddress(),
          //   },
          // },
          {
            id: 4,
            type: types.actions.button,
            attr: {
              type: 'primary',
              label: 'Следующий шаг',
              disabled: this.addressListFilledLength === 0,
              handler: () => this.toNextStep(),
            },
          },
        ],
      }
    },
    formList() {
      return [
        {
          id: 'address',
          label: 'Выберите дом',
          required: true,
          type: types.components.select,
          width: 7,
          attr: {
            placeholder: 'Выберите дом',
            options: this.propertyListOptions,
          },
        },
        {
          id: 'server',
          label: 'Выберите сервер',
          required: true,
          type: types.components.select,
          width: 5,
          attr: {
            placeholder: 'Выбрать',
            options: this.serverListOptions,
            // options: [],     // Если не будет опций - покажет кнокку "Добавить сервер" (ниже)
          },
          nooptions: {
            label: 'Добавить сервер',
            icon: 'plus-outlined',
            handler: () => this.onAddServer(),
          },
        },
        {
          id: 'tariff_type',
          type: types.components.switcher,
          width: 5,
          component: {
            type: 'switcher',
            'label-true': 'Суммарно',
            'label-false': 'День/Ночь',
          },
          label: 'Схема учета',
        },
        // {
        //   id: 'tariff_type',
        //   component: {
        //     type: 'switcher',
        //     'label-true': 'Суммарно',
        //     'label-false': 'День/Ночь',
        //   },
        //   label: 'Схема учета',
        //   onclick: () => {},
        //   clickable: false,
        //   selected: this.filtersData.order === 'tariff_type',
        // },
      ]
    },
    addressListFilledLength() {
      return this.addressList.reduce((acc, item) => {
        const addr = item.form.address
        const serv = item.form.server
        // const file = item.file;

        // if (!addr || !serv || !addr.length || !serv.length || !file) return acc;
        if (!addr || !serv || !addr.length || !serv.length) return acc

        ++acc
        return acc
      }, 0)
    },
    isAddNewAvailable() {
      return this.addressList.length === this.addressListFilledLength
    },
  },
  methods: {
    getBlankAddress() {
      return {
        id: Math.random(),
        form: {
          address: [],
          server: [],
          tariff_type: 1,
        },
        // file: null,
      }
    },
    addAddress() {
      this.addressList.push(this.getBlankAddress())
    },
    removeAddress(id) {
      this.addressList = this.addressList.filter(item => item.id !== id)
    },
    getPreparedAdressData() {
      let preparedAddressData = {}

      this.addressList.forEach(address => {
        preparedAddressData = {
          organization_id: this.currentOrganizationId,
          property_id: address.form.address ?? null,
          enviro_server_id: address.form.server ?? null,
          tariff_type: address.form.tariff_type ?? 1,
          // contacts_file: address.file
        }
      })

      return preparedAddressData
    },
    toNextStep() {
      this.$store.dispatch('setIsLoading', true)
      this.meterConfigService
        .addMeterConfig(this.getPreparedAdressData())
        .then(response => {
          this.$store.dispatch(
            'setTempMeterConfigIds',
            response.data.enviro_server_contact_config_id ?? null
          )
          this.$store.dispatch('setIsLoading', false)
          this.$router.push({ name: 'Units' })
        })
        .catch(error => {
          console.log(error)
          this.$store.dispatch('setIsLoading', false)
        })
    },
  },
  mounted() {
    this.getServers({
      organizationId: this.currentOrganizationId,
    })

    this.getProperties({
      organizationId: this.currentOrganizationId,
    })
  },
}
